// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import CheckboxPresentationPropsDefault from "@insite/mobius/Checkbox/presentationProps";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { getProp } from "@insite/mobius/utilities";
import { xBaseTheme } from "@keller/XDL/types";
import { color } from "@keller/XDL/Utilities";
import { css } from "styled-components";

interface CheckboxSizesProps {
    fontSize: number;
    iconSize: number;
    borderRadius: number;
}

export const checkboxSizes: {
    [key: string]: CheckboxSizesProps;
} = {
    default: {
        fontSize: 12,
        iconSize: 18,
        borderRadius: 0,
    },
    small: {
        fontSize: 10,
        iconSize: 12,
        borderRadius: 0,
    },
};

export default {
    defaultProps: {
        ...CheckboxPresentationPropsDefault,
        mergeCss: true,
        typographyProps: {
            mergeCss: true,
            size: 12,
            css: css`
                letter-spacing: 0;
                line-height: 18px;
            `,
        },
        iconProps: {
            src: "Check",
            size: checkboxSizes.default.iconSize,
        },
        indeterminateIconProps: {
            src: "Minus",
            size: checkboxSizes.default.iconSize,
        },
        css: css`
            cursor: ${({ disabled }: any) => (disabled ? "not-allowed" : "pointer")};

            span[role="checkbox"] {
                border-radius: ${({ _sizeVariant }: any) => checkboxSizes[_sizeVariant].borderRadius}px;
                min-width: ${({ _sizeVariant }: any) => checkboxSizes[_sizeVariant].iconSize}px;
                border: 1px solid ${color("common.ui6")};
                transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;
                cursor: pointer;
                padding: 1px;

                &[aria-disabled="true"] {
                    cursor: not-allowed;
                }

                &[aria-checked="true"]:not([aria-disabled="true"]),
                &[aria-checked="mixed"]:not([aria-disabled="true"]) {
                    background: ${color("common.ui6")};
                    border: 0;
                    color: ${color("common.white")};
                }
                &:focus {
                    outline: none;
                    box-shadow: none;
                }

                & + label {
                    word-break: break-all;
                }
            }

            &:hover {
                span[role="checkbox"] {
                    &[aria-checked="true"]:not([aria-disabled="true"]),
                    &[aria-checked="mixed"]:not([aria-disabled="true"]) {
                        background: ${color("common.ui1")};
                        border-color: ${color("common.ui1")};
                    }
                    &[aria-checked="false"]:not([aria-disabled="true"]) {
                        border-color: ${color("common.ui1")};
                    }
                }
            }

            &:focus {
                span[role="checkbox"] {
                    outline: none;
                    box-shadow: none;
                }
            }
        `,
    },
    groupDefaultProps: {
        mergeCss: true,
        css: css`
            & > ${TypographyStyle}:empty {
                display: none;
            }
        `,
    },
} as xBaseTheme["checkbox"];
